module.exports = __webpack_public_path__ + "img/38a0d41.jpg";